<!-- =========================================================================================
  File Name: UserDetail.vue
  Description: User Detail Page
  ----------------------------------------------------------------------------------------
  Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <div id="main-container">

    <div class="vx-row mt-5">
      <div class="vx-col sm:w-1/2 w-full mb-base">
        <h1>{{ user.first_name }} {{ user.last_name }} (ID: {{ user.user_id }})</h1>
      </div>
    </div>

    <vx-card class="mb-8">
      <h4 class="mb-4">Account Information</h4>

      <vs-row>
        <vs-col vs-w="6">
          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Name</vs-col>
            <vs-col vs-w="8">{{ user.first_name }} {{ user.last_name }}</vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Email</vs-col>
            <vs-col vs-w="8">{{ user.email }}</vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Phone</vs-col>
            <vs-col vs-w="8">{{ user.phone }}</vs-col>
          </vs-row>
        </vs-col>

        <vs-col vs-w="6">
          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">PayPal Email</vs-col>
            <vs-col vs-w="8">{{ user.paypal_email || "-" }}</vs-col>
          </vs-row>
          <vs-row>
            <vs-col vs-w="4" style="font-weight: bold;">Address</vs-col>
            <vs-col vs-w="8">
              {{ user.address }}<br>
              {{ user.address_2 }}<br v-if="user.address_2 != null">
              {{ user.city }}, {{ user.state }} {{ user.postal_code }}<br>
              {{ user.country }}
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row class="mt-4">
        <vs-button @click="editUser()" class="ml-0">
          <feather-icon icon="EditIcon" svgClasses="h-4 w-4"/>
          <span class="text-sm font-semibold ml-2">EDIT</span>
        </vs-button>
        <vs-button v-if="showForgetButton" class="ml-auto" color="danger" icon="delete_outline" type="gradient" @click="confirmForgetUserEmail">Send Forget User Email</vs-button>
        <vs-button v-if="showForgetButton" class="ml-2" color="danger" icon="delete_outline" type="gradient" @click="confirmForgetUser">Forget User</vs-button>
      </vs-row>
    </vx-card>

    <div class="vx-row mb-8">
      <div class="vx-col w-1/2">
        <vx-card>
          <vs-row class="mb-5">
            <vs-col vs-type="flex" vs-align="center" vs-w="6">
              <h4>Notes</h4>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
              <vs-button @click="showAddUserNote=true">Add Note</vs-button>
            </vs-col>
          </vs-row>


          <div class="scroll-box">
            <div v-for="(note, index) in user.notes" :key="index">
              <hr>
              <div class="vx-row mt-4 mb-4" style="width: 95%;">
                <div class="vx-col w-1/4">
                  {{ note.date }}<br>
                  {{ note.time }}<br>
                  <span v-if="note.admin != null">{{ note.admin.name }} {{ note.admin.last_name }}</span>
                </div>

                <div class="vx-col w-3/4">
                  {{ note.note_content }}
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <div class="vx-col w-1/2">
        <UserDnaCard
          :user-id="userId">
        </UserDnaCard>
      </div>

    </div>


    <vs-collapse type="margin" class="mt-1 mb-6" >
      <vs-collapse-item style="background-color: #fff;">
        <div slot="header">
          <h3>Referrals (total {{user.referrals.length}})</h3>
        </div>

        <vx-card v-for="(level) in referralLevels" :key="`referral-level-${level.id}`" class="mb-8" style="cursor: default;">
          <h4 class="mb-5">{{level.description}}</h4>

          <vs-row>
            <vs-col vs-w="1">#</vs-col>
            <vs-col vs-w="3">Referral Name</vs-col>
            <vs-col vs-w="2">Signup Date</vs-col>
            <vs-col vs-w="2" v-if="level.payout">Check Status</vs-col>
            <vs-col vs-w="2" v-if="level.payout">Check Date</vs-col>
            <vs-divider></vs-divider>
          </vs-row>

          <vs-row v-for="(referral, index) in level.referrals" :key="`referral-${referral.referral_id}`">
            <vs-col vs-w="1">{{ index + 1 }}</vs-col>
            <vs-col vs-w="3">{{ `${referral.user.first_name} ${referral.user.last_name} (ID: ${referral.user_id})` }}</vs-col>
            <vs-col vs-w="2">{{ referral.created_at.format("MMMM Do YYYY") }}</vs-col>
            <vs-col vs-w="2" v-if="level.payout">{{ referral.pending ? "In waiting period" : referral.checkDate ? "Complete" : "Check Pending" }}</vs-col>
            <vs-col vs-w="4" v-if="level.payout">{{ (referral.checkDate) ? `${referral.checkDate.format("MMMM Do YYYY")} (Invoice ID: ${referral.checkInvoiceId})` : "" }}</vs-col>

            <vs-divider></vs-divider>
          </vs-row>

          <h5 v-if="level.earned !== undefined">Level earned: {{ level.earned ? 'Yes' : 'No' }}</h5>
        </vx-card>
      </vs-collapse-item>
    </vs-collapse>

    <add-user-note-dialog :showAddUserNote.sync="showAddUserNote" :userId.sync="user.user_id" :fetchUser="fetchUser"/>
  </div>
</template>

<script>
  import Vue from 'vue'
  import api from '@/http/api';
  import types from '@/models';
  import jsonHtml from '@/misc/jsonHtmlPrinter';
  import moment from 'moment';
  import VueOverflowScroll from 'vue-overflow-scroll'
  import UserDnaCard from './components/UserDnaCard';
  import AddUserNoteDialog from "@/views/users/components/AddUserNoteDialog";

  Vue.use(VueOverflowScroll)

  import helpers from '@/models/helpers';

  export default {
    components: {
      UserDnaCard,
      AddUserNoteDialog
    },
    mounted() {
      this.fetchUser();
    },
    data() {
      return {
        jsonHtml: jsonHtml,
        unsavedChanges: {
          general: false,
          baseLocalization: false,
          companyGroups: false,
        },
        types: types,
        isLoading: false,
        user: new types.User(),
        helpers: helpers,
        showForgetButton: false,
        showAddUserNote: false,
        referralLevels: [],
      }
    },
    computed: {
      userId() {
        return this.$route.query.id || null;
      },
      howManyUnsavedChanges() {
        let count = 0;
        let keys = Object.keys(this.unsavedChanges);
        for (let i = 0; i < keys.length; i++) {
          if (this.unsavedChanges[keys[i]]) {
            count++;
          }
        }
        return count;
      },
    },
    watch: {
      isLoading(oldVal, newVal) {
        if (!newVal) {
          this.$vs.loading();
        } else {
          this.$vs.loading.close();
        }
      }
    },
    methods: {
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
      confirmForgetUserEmail() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'SEND EMAIL',
          title: `SEND FORGET USER EMAIL`,
          text: `Are you sure you want to send the forget user email to this user? (User's personal information will be deleted if they reply confirming they want to do it.)`,
          accept: () => {
            this.forgetUserEmail();
          }
        })
      },
      async forgetUserEmail() {
        this.$vs.loading();
        const success = await api.sendForgetUserEmail(this.userId);
        this.$vs.loading.close();
        this.showNotification(success, !success ? 'COULD NOT SEND FORGET USER EMAIL' : '');
      },
      confirmForgetUser() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'FORGET',
          title: `FORGET USER`,
          text: `Are you sure you want to forget this user? This action is permanent. (User's personal information will be deleted.)`,
          accept: () => {
            this.forgetUser();
          }
        })
      },
      async forgetUser() {
        this.$vs.loading();
        const success = await api.forgetUser(this.userId);
        this.$vs.loading.close();
        this.showNotification(success, !success ? 'COULD NOT FORGET USER' : '');
        if (success) {
          this.$router.go();
        }
      },
      async fetchUser() {
        this.$vs.loading();
        let user = await api.fetchUser(this.userId);
        if (user === null) {
          // todo: handle error
        }

        for (let i = 0; i < user.notes.length; i++) {
          user.notes[i].date = moment(user.notes[i].creation_date).format('MM/DD/YYYY');
          user.notes[i].time = moment(user.notes[i].creation_date).format('hh:mmA');
        }

        if(user.notes.length) user.notes.reverse();

        this.user = user;

        this.showForgetButton = !this.hasActiveSubscription() && !this.hasActiveCyclopediaSubscription();

        await this.fetchReferrals();

        this.$vs.loading.close();
      },
      async fetchReferrals() {
        let referralLevels = await api.getUserReferralsBreakdown(this.userId);

        referralLevels.forEach((level) => {
          level.referrals.forEach((referral) => {
            referral.created_at = moment(referral.created_at);

            this.user.invoices.forEach((invoice) => {
              invoice.subdata_json.lineitems.forEach((lineItem) => {
                if (invoice.creation_source === "referral_commission") {
                  let referralUserIds = lineItem.referral_user_ids;
                  let referralUserIdsArray = referralUserIds.split(",");

                  if ( referralUserIds === referral.user_id.toString() || referralUserIdsArray.includes(referral.user_id.toString()) ) {
                    let lastTransactionIndex = invoice.transactions.length - 1;

                    if (0 < invoice.transactions.length && invoice.transactions[lastTransactionIndex].status === "paper_check_sent") {
                      let paymentDetailJson = JSON.parse(invoice.transactions[lastTransactionIndex].payment_detail_json);
                      referral.checkDate = moment(paymentDetailJson.check_date);
                      referral.checkInvoiceId = invoice.invc_id;
                    }
                  }
                }
              });
            });
          });
        });

        this.referralLevels = referralLevels;
      },
      hasActiveSubscription() {
        if (this.user.subscriptions === undefined) {
          return false;
        }

        var ret = false;
        this.user.subscriptions.forEach((subscription) => {
          if (subscription.status === "active") {
            ret = true;
          }
        });

        return ret;
      },
      hasActiveCyclopediaSubscription() {
        if (this.user.cyclopedia_subscriptions === undefined) {
          return false;
        }

        var ret = false;
        this.user.cyclopedia_subscriptions.forEach((subscription) => {
          if (subscription.status === "active") {
            ret = true;
          }
        });

        return ret;
      },
      editUser() {
        this.$router.push('/users/edit?id=' + this.user.user_id);
      },
    },
    beforeRouteLeave(to, from, next) {
      if (this.howManyUnsavedChanges <= 0) {
        next();
      } else {
        // next(false);
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to leave this page? You will lose your unsaved changes.',
          accept: () => {
            next()
          }
        });
      }
    },
  }

</script>


<style lang="scss">
  #main-container {

    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

  .scroll-box {
    overflow-y: scroll;
    max-height: 400px;
  }

  .scroll-box::-webkit-scrollbar {
    -webkit-appearance: none;
  }

  .scroll-box::-webkit-scrollbar:vertical {
    width: 11px;
  }

  .scroll-box::-webkit-scrollbar:horizontal {
    height: 11px;
  }

  .scroll-box::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
  }

</style>

